import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { navigate } from "gatsby"
import SquareCard from "../cards/squareCard"
import styled from "styled-components"
import { APP_ID } from "../../helpers/constants"
import { getFormattedCurrency } from "@omnichannel/ace-b2b-elements"
import noImage from "../../images/no-image.png"

const trimText = (string, dimension, defaultCharCount = 0) => {
    const windowWidth = dimension
    let frame320 = windowWidth && windowWidth <= 320
    let frame360 = windowWidth && windowWidth <= 360
    let frame375 = windowWidth && windowWidth <= 375
    let frame412 = windowWidth && windowWidth <= 412
    let frame550 = windowWidth && windowWidth <= 550
    let frame600 = windowWidth && windowWidth <= 600
    let frame768 = windowWidth && windowWidth <= 768
    let frame1280 = windowWidth && windowWidth <= 1280

    let charCount = 60
    if (frame320) {
        charCount = 30
    } else if (frame360) {
        charCount = 30
    } else if (frame375) {
        charCount = 35
    } else if (frame412) {
        charCount = 35
    } else if (frame550) {
        charCount = 35
    } else if (frame600) {
        charCount = 35
    } else if (frame768) {
        charCount = 45
    } else if (frame1280) {
        charCount = 60
    }

    if (defaultCharCount > 0) {
        charCount = defaultCharCount
    }
    if (string && string.length <= charCount) {
        return string
    }

    return string && `${string.substring(0, charCount)}...`
}


const BoundedWrapperBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const SliderBox = styled.div`
  display: block;
  width: 100%;
  max-width: 140rem;
  & > .slick-slider  div {
    outline: none;
  }
  & > .slick-slider > .slick-dots > li button::before {
    font-size: 1rem;
    /* color: ${props => props.theme[APP_ID].secondary}; */
    color: #ef0a0a;
    // margin-top: 0rem;
  }
  padding: 0 .8rem;
  margin: 0 auto;
  @media (min-width: 768px) {
      padding: 0 2rem;
  }
  @media (min-width: 1280px) {
    padding: 0rem 4rem;
}
`

const CarouselBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`

const HeaderBox = styled.div`
    width: 100%;
`

const BannerBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const BannerImage = styled.img`
    display: block;
    width: 100%;
    cursor: pointer;
`

const TitleAndSeeAllBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 2rem 1rem 1.2rem 1.2rem;
    width: 100%;
    max-width: 140rem;
    @media (min-width: 768px) {
        padding: 2.4rem 2.2rem 1.6rem 2.2rem;
    }
    @media (min-width: 1280px) {
        padding: 2.4rem 4.2rem 1.6rem 4.2rem;
    }
`

const TitleBox = styled.div`
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    @media (min-width: 961px) {
        font-size: 2rem;
    }
    @media (min-width: 1280px) {
        font-size: 2.4rem;
    }
    user-select: none;
`

const Heading = styled.h1`
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    @media (min-width: 961px) {
        font-size: 2rem;
    }
    @media (min-width: 1280px) {
        font-size: 2.4rem;
    }
    user-select: none;
    padding: 0;
    margin: 0;
`

const SeeAllBox = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 1.4rem;
    font-weight: 600;
    text-transform: uppercase;
    /* color: ${props => props.theme.default.primary}; */
    color: #ef0a0a;
    cursor: pointer;
    user-select: none;
    @media (min-width: 768px) {
        font-size: 1.4rem;
    }
`

const MobileView = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    @media (min-width: 768px) {
        display: none;
    }
`

const WebView = styled.div`
    display: none;
    @media (min-width: 768px) {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
`

const TitleAndSeeAllSpacerBox = styled.div`
    height: 1.6rem;
    @media (min-width: 768px) {
        height: 2rem;
    }
    @media (min-width: 1024px) {
        height: 2.4rem;
    }
`

const BottomSeeAllBox = styled(SeeAllBox)`
    width: 100%;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: -4.2rem;
    @media (min-width: 768px) {
        bottom: -4.2rem;
    }
    @media (min-width: 1024px) {
        bottom: -4.4rem;
    }
`

const Carousel = ({ widget = {}, settings = {}, width }) => {


    const data = (widget && widget.skus) ? widget : { skus: [], widget: {} }
    const displayNameAsTitle = data.widget.displayNameAsTitle
    const name = data.widget.name

    const fullNumberSkus = [...data.skus]
    const only12Skus = [...data.skus].splice(0, 12)

    const skusToDisplay = width >= 1301 ? fullNumberSkus : only12Skus;

    // console.log("skus to display::", width)

    const CarouselData = skusToDisplay.map((sku, i) => {
        return (
            <div key={sku._id}>
                <SquareCard
                    key={sku._id}
                    skuId={sku._id}
                    cardImgSrc={sku.image ? sku.image.base64_500 : noImage}
                    currentPrice={getFormattedCurrency(sku.currentPrice)}
                    referencePrice={getFormattedCurrency(sku.referencePrice)}
                    category={sku.brandName}
                    discount={sku.discount}
                    // productName={trimText(sku.commercialName, width)}
                    productName={sku.commercialName}
                    rating={sku.rating !== "NaN" ? sku.rating : 0}
                    onClick={() => navigate("/product/" + sku._id)}
                />
            </div>
        )
    })

    return (
        <CarouselBox>
            <HeaderBox>
                <BannerBox>
                    <MobileView>
                        <BannerImage
                            src={data.widget.base64_mobile}
                            draggable={false}
                            onClick={() => {
                                sessionStorage.removeItem(`${name}::scrollTo`)
                                navigate(`/products/${name}`)
                            }}
                        />
                    </MobileView>
                    <WebView>
                        <BannerImage
                            src={data.widget.base64}
                            draggable={false}
                            onClick={() => {
                                sessionStorage.removeItem(`${name}::scrollTo`)
                                navigate(`/products/${name}`)
                            }}
                        />
                    </WebView>
                </BannerBox>
                {
                    displayNameAsTitle ? (
                        <BoundedWrapperBox>
                            <TitleAndSeeAllBox>
                                <TitleBox><Heading>{displayNameAsTitle && name}</Heading></TitleBox>
                                <SeeAllBox onClick={() => {
                                    sessionStorage.removeItem(`${name}::scrollTo`)
                                    navigate(`/products/${name}`)
                                }}>{'Show all >'}</SeeAllBox>
                            </TitleAndSeeAllBox>
                        </BoundedWrapperBox>
                    ) : <TitleAndSeeAllSpacerBox />
                }
            </HeaderBox>
            <SliderBox>
                <Slider {...settings}>
                    {CarouselData}
                </Slider>
            </SliderBox>
            {!displayNameAsTitle && <BottomSeeAllBox onClick={() => {
                sessionStorage.removeItem(`${name}::scrollTo`)
                navigate(`/products/${name}`)
            }}>{'Show all >'}</BottomSeeAllBox>}
        </CarouselBox >
    );
}

export default Carousel
